import { render, staticRenderFns } from "./ArtistItems.vue?vue&type=template&id=afda00d4&scoped=true"
import script from "./ArtistItems.vue?vue&type=script&lang=js"
export * from "./ArtistItems.vue?vue&type=script&lang=js"
import style0 from "./ArtistItems.vue?vue&type=style&index=0&id=afda00d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afda00d4",
  null
  
)

export default component.exports